import {useDispatch} from 'react-redux';
import {Form, Formik} from 'formik';
import {debounce} from 'lodash';
import {useTranslate} from 'core/i18n/i18nProvider';
import {DatePickerField} from 'app/common/_partials/controls';
import {
  getCustomerReportByPaginationAction,
  getCustomerExcelReportAction,
  getCustomersAction
} from '../redux/reportActions';
import AsyncSelect from "react-select/async";
import { useEffect, useState } from 'react';

export default function CustomerReportViewFilter({queryParams, setQueryParams}) {
  const {t} = useTranslate();
  const dispatch = useDispatch();
  const prepareFilter = (queryParams, values) => {
    const {startDate, endDate, name} = values;
    const newQueryParams = {...queryParams};
    newQueryParams.name = name;
    newQueryParams.startDate = startDate ? new Date(startDate).toDateString(): '';
    newQueryParams.endDate = endDate ? new Date(endDate.getTime() + 86400000).toDateString() : new Date(Date.now() + 86400000).toDateString();
    return newQueryParams;
  };
  const [customerReportByPagination, setCustomerReportByPagination] = useState([]); 
  const [customers, setCustomers] = useState([])
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(queryParams, values);
    if (!newQueryParams.paging) {
      newQueryParams.paging = {};
    }
    newQueryParams.pageNumber = 1;
    setQueryParams(newQueryParams);
  };

  const searchCustomer = (query) => {
    const params = {
      filter: {
        q: query
      },
      paging: {
        pageNumber: 1,
        pageSize: 1000,
      },
    };
    return dispatch(getCustomersAction(params)).then((response) => {
      let customers = response.data;
      return customers.map((customer) => {
          return {
            value: customer.name,
            label: customer.name,
          };
      });
    });
  };

  useEffect(() => {
    loadCustomerReport();
  }, [dispatch, queryParams]);

  useEffect(() => {
    loadCustomer();
  }, [dispatch]);

  const loadCustomerReport = () => {
    const params = {
      ...queryParams,
      paging: {
        pageNumber: queryParams.pageNumber,
        pageSize: queryParams.pageSize,
      },
    };
    dispatch(getCustomerReportByPaginationAction(params)).then(res => {
      let customerReports = res.data.data ?? [];
      let totalQuantityReport = 0;
      let totalRevenueReport = 0;
      customerReports = customerReports.map((customerReport) => {
        totalQuantityReport += customerReport.quantity;
        totalRevenueReport += customerReport.totalAmount;
      });
      setCustomerReportByPagination(res.data.data);
    });
  };

  const loadCustomer = () => {
    const params = {
      paging: {
        pageNumber: 1,
        pageSize: 1000,
      },
    };
    dispatch(getCustomersAction(params)).then(res => {
      let customers = res.data;
      customers = customers.map((customer) => {
        return {
          value: customer.name,
          label: customer.name,
        };
      });
      setCustomers(customers);
    });
  };

  const exportExcel = () => {
    const params = {
      ...queryParams,
    };
    dispatch(getCustomerExcelReportAction(params)).then(res => {
      window.open(res.data);
    });
  }
  return (
    <>
      <Formik
        initialValues={{
          searchText: '',
        }}
        onSubmit={(values) => {
          applyFilter(values);
        }}
      >         
        {({handleSubmit, handleBlur, setFieldValue}) => (
          <Form className='row d-flex w-100'>
              <div className='col-6 mt-4 d-flex align-items-center justify-content-between mb-5'>
              <div className='col-lg- customer'></div>
                <div className='col-lg-5 customer'>
                <AsyncSelect
                className='product-filter-select'
                    cacheOptions
                    maxMenuHeight={200}
                    placeholder="Tên khách hàng"
                    defaultOptions= {customers}
                    isMulti
                    loadOptions={debounce(searchCustomer, 100)} 
                    onBlur={handleBlur}
                    onChange={(val) => {
                      setFieldValue('name',val);
                    }}
                  />
                </div>
              </div>
              <div className='col-6 mt-4 d-flex align-items-center justify-content-between mb-5'>
              <div className='col-lg-4'>
                  <DatePickerField className='custom-date-picker' name='startDate' dateFormat='dd/MM/yyyy' placeholderText={'Ngày bắt đầu'}/>
                </div>
                <div className='col-lg-4'>
                  <DatePickerField className='custom-date-picker' name='endDate' dateFormat='dd/MM/yyyy' placeholderText={'Ngày kết thúc'} />
                </div>
                 <div>
                    <button type='button' onClick={handleSubmit} className='btn btn-secondary btn-sm float-right h-40px'>
                      {t('common_search')}
                    </button>
                </div>
                <div>
                    <button type='button' onClick={exportExcel} className='btn btn-primary btn-sm float-right ms-2 w-100px h-40px'>
                    Xuất excel
                    </button>
                </div>
              </div>
          </Form>
        )}
      </Formik>
    </>
  );
}
